import { IRegistry } from '@cian/mf-registry/browser';
import { ILogger } from '@cian/logger';

import {
  EPaymentWidgetResultStatus,
  IDepositWidgetParams,
  IPaymentWidgetMicrofrontendAPI,
  TPaymentWidgetResult,
} from '../../types';

interface IParams {
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export const getPaymentWidgetMicrofrontendAPI = (params: IParams): IPaymentWidgetMicrofrontendAPI => {
  const { logger, microfrontendsRegistry } = params;

  const paymentWidgetApiCall = async <Params>(path: string, params: Params): Promise<TPaymentWidgetResult> => {
    try {
      const api = await microfrontendsRegistry.microfrontendStrict('payment-widget-frontend').api()!.ensure();

      return api.call(path, params);
    } catch (error) {
      logger.error(error, {
        domain: 'microfrontends.payment-widget.api-call',
        details: { path, params: JSON.stringify(params) },
      });

      return { status: EPaymentWidgetResultStatus.Cancel };
    }
  };

  return {
    openDepositModal: (params: IDepositWidgetParams) => {
      return paymentWidgetApiCall<IDepositWidgetParams>('/v1/open-deposit-modal', params);
    },
  };
};
